import { type } from "arktype";

// PRD §6.2 R-DOM-01: every derived record carries its epistemic layer.
export const layers = ["fact", "signal", "interpretation"] as const;
export const Layer = type.enumerated(...layers);
export type Layer = typeof Layer.infer;

// R-DOM-02: provisional is a state. Facts only ever carry approved | superseded.
export const statuses = ["provisional", "approved", "rejected", "superseded"] as const;
export const Status = type.enumerated(...statuses);
export type Status = typeof Status.infer;

// R-DOM-08: supervision is data.
export const supervisions = ["coach_supervised", "unsupervised_self_report", "imported"] as const;
export const Supervision = type.enumerated(...supervisions);
export type Supervision = typeof Supervision.infer;

// R-DOM-04: provenance is mandatory on signals and interpretations.
export const provenanceKinds = [
  "session", "set", "assessment", "intake", "goal", "check_in", "question",
  "review", "hypothesis", "signal", "knowledge_source", "method", "self_report", "poor_response",
] as const;
export const ProvenanceRef = type({ kind: type.enumerated(...provenanceKinds), id: "string" });
export type ProvenanceRef = typeof ProvenanceRef.infer;
export const Provenance = ProvenanceRef.array();
export type Provenance = typeof Provenance.infer;

// R-EVI-01 / R-EVI-02
export const evidenceLevels = ["none", "thin", "moderate", "strong"] as const;
export const EvidenceLevel = type.enumerated(...evidenceLevels);
export type EvidenceLevel = typeof EvidenceLevel.infer;

export const ceilings = ["assess", "establish_working_load", "prescribe_range", "prescribe_exact"] as const;
export const Ceiling = type.enumerated(...ceilings);
export type Ceiling = typeof Ceiling.infer;

export const confidenceBands = ["low", "moderate", "high"] as const;
export const ConfidenceBand = type.enumerated(...confidenceBands);
export type ConfidenceBand = typeof ConfidenceBand.infer;

/** Fields every derived (signal / interpretation) record carries. */
export const Derived = type({
  layer: Layer,
  status: Status,
  provenance: Provenance,
  observedAt: "string",
  effectiveAt: "string",
  "supersedesId?": "string | null",
});
export type Derived = typeof Derived.infer;
